<template>
  <div id="app-center">
    <home-head></home-head>
    <home-nav></home-nav>
    <div class="center-box">
      <div class="center-list">
        <h3>患者救助申请</h3>
        <div class="center-left"
             style="padding-top: 0">
          <el-form ref="applyForm"
                   :model="form"
                   :rules="ruleValidate"
                   label-width="170px">
            <el-alert :title="cueTitle"
                      :type="cueType"
                      :description="cueDesc"
                      :closable="false"
                      show-icon
                      v-if="form.id"></el-alert>
            <table class="table">
              <tr>
                <td colspan="2"
                    class="sort-box">
                  <h3>基础信息</h3>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="姓名："
                                prop="user_name">
                    <el-input v-model="form.user_name"
                              style="width: 80%"
                              size="small"
                              :maxlength="20"
                              placeholder="请输入申请者姓名,最大输入20个字符"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="身份证号码："
                                prop="user_cardno">
                    <el-input v-model="form.user_cardno"
                              style="width: 80%"
                              size="small"
                              ref="idCard"
                              placeholder="请输入身份证号码,请输入18个字符"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="出生日期："
                                prop="birthday">
                    <el-date-picker v-model="form.birthday"
                                    type="date"
                                    size="small"
                                    style="width: 80%"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择出生日期"></el-date-picker>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="户籍所在地："
                                prop="domicile">
                    <el-input v-model="form.domicile"
                              style="width: 80%"
                              size="small"
                              :maxlength="50"
                              placeholder="请输入户籍所在地,最大输入50个字符"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="籍贯："
                                prop="jg">
                    <el-input v-model.trim="form.jg"
                              style="width: 80%"
                              size="small"
                              :maxlength="50"
                              placeholder="请输入户籍贯"
                              suffix-icon="el-icon-edit"></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="患者性别："
                                prop="user_sex">
                    <el-radio-group v-model="form.user_sex">
                      <el-radio :label="1">男</el-radio>
                      <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="联系方式："
                                prop="phone">
                    <el-input v-model="form.phone"
                              style="width: 80%"
                              size="small"
                              :maxlength="11"
                              placeholder="请输入患者手机号码,请输入11个字符"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="患者微信号："
                                prop="wechat_no">
                    <el-input v-model="form.wechat_no"
                              style="width: 80%"
                              size="small"
                              :maxlength="50"
                              placeholder="请输入患者微信号,最大输入50个字符"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="经手志愿者联系方式："
                                prop="volunteer_phone">
                    <el-input v-model="form.volunteer_phone"
                              style="width: 80%"
                              size="small"
                              :maxlength="11"
                              placeholder="请输入经手志愿者手机号码,请输入11个字符"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="经手志愿者微信号："
                                prop="volunteer_wechat">
                    <el-input v-model="form.volunteer_wechat"
                              style="width: 80%"
                              size="small"
                              :maxlength="50"
                              placeholder="请输入经手志愿者微信号,最大输入50个字符"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <!-- <el-form-item label="籍贯：" prop="birthplace">
                    <el-input
                      v-model="form.birthplace"
                      style="width: 80%"
                      size="small"
                      :maxlength="10"
                      placeholder="请输入籍贯,最大输入10个字符"
                      suffix-icon="el-icon-edit"
                      onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"
                    ></el-input>
                  </el-form-item>-->
                </td>
                <td>
                  <el-form-item label="家庭年收入总计(万)：">
                    <el-input-number :min="0"
                                     style="width: 80%"
                                     size="small"
                                     :max="999999999"
                                     v-model="form.family_year_income"
                                     type="number"
                                     placeholder="请输入家庭年收入,保留两位小数(例如：200.00)"
                                     :precision="2"
                                     :controls="false"></el-input-number>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="居住地址："
                                prop="province_id"
                                required>
                    <!-- <WtDataArea v-model="region1"></WtDataArea> -->
                    <el-select v-model="form.province_id"
                               size="small"
                               placeholder="请选择省份"
                               style="width: 30%"
                               @change="getCity"
                               :popper-append-to-body="false">
                      <el-option v-for="item in provinceList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                    <el-select v-model="form.city_id"
                               size="small"
                               ref="city"
                               placeholder="请选择城市"
                               style="width: 30%"
                               @change="getCounty"
                               :clearable="true"
                               :popper-append-to-body="false">
                      <el-option v-for="item in cityList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                    <el-select v-model="form.county_id"
                               size="small"
                               ref="county"
                               placeholder="请选择县/区"
                               style="width: 30%"
                               :clearable="true"
                               :popper-append-to-body="false">
                      <el-option v-for="item in countyList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="详细住址：">
                    <el-input v-model.trim="form.home_address"
                              style="width: 91%"
                              size="small"
                              :maxlength="100"
                              placeholder="请输入家庭住址,最大输入100个字符"
                              suffix-icon="el-icon-edit"></el-input>
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td colspan="2"
                    class="sort-box">
                  <h3>申请信息</h3>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="执行机构所在地址：">
                    <el-select :clearable="true"
                               v-model="p_province_id"
                               size="small"
                               placeholder="请选择省份"
                               style="width: 30%"
                               @change="getCityHospital"
                               :popper-append-to-body="false">
                      <el-option v-for="item in p_provinceList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                    <el-select v-model="p_city_id"
                               size="small"
                               ref="city"
                               placeholder="请选择城市"
                               style="width: 30%"
                               @change="getCountyHospital"
                               :clearable="true"
                               :popper-append-to-body="false">
                      <el-option v-for="item in p_cityList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                    <el-select @change="changeCountryHospital"
                               v-model="p_county_id"
                               size="small"
                               ref="county"
                               placeholder="请选择县/区"
                               style="width: 30%"
                               :clearable="true"
                               :popper-append-to-body="false">
                      <el-option v-for="item in p_countyList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="具体执行机构："
                                prop="unit_id">
                    <el-select v-model="form.unit_id"
                               :popper-append-to-body="false"
                               clearable
                               style="width: 91%"
                               placeholder="请根据上面一行的执行机构所在地址，选择具体的执行机构">
                      <el-option v-for="item in specificHospital"
                                 :key="item.unit_name"
                                 :label="item.unit_name"
                                 :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="申请人类别：">
                    <el-checkbox-group v-model="form.apply_type">
                      <el-checkbox v-for=" (item,index) in apply_data"
                                   :key="index"
                                   :label="item.value"
                                   border>{{item.text}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="收入主要来源：">
                    <el-input type="textarea"
                              style="width: 80%"
                              :maxlength="200"
                              v-model="form.revenue_sources"
                              placeholder="请输入收入主要来源,最大输入200个字符："
                              :autosize="{ minRows: 2, maxRows: 4}"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="诊断详细说明：">
                    <el-input type="textarea"
                              style="width: 80%"
                              :maxlength="225"
                              v-model="form.description"
                              placeholder="请输入何时、何执行机构诊断、诊断结果,最大输入225个字符:"
                              :autosize="{ minRows: 2, maxRows: 4}"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <p style="color:#b60205;margin-left:56px;padding:20px 0px">
                  <i class="el-icon-info">身份证和户口照片至少上传一种~</i>
                </p>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="身份证正反面：">
                    <el-upload name="img"
                               multiple
                               :action="uploadImgUrl"
                               :data="{file_type:2}"
                               list-type="picture-card"
                               :file-list="defFiles1"
                               :before-upload="beforeUpload"
                               :on-success="(response, file, fileList) =>{
                        this.defFiles1 = fileList;
                      }"
                               :on-remove="( file, fileList) =>{
                        this.defFiles1 = fileList;
                      }"
                               :on-preview="previewImg"
                               ref="uploadRef1">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <i class="el-icon-info">上传jpg、jpeg、png，且大小不能超过50M的图片</i>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="户主和本人照片：">
                    <el-upload name="img"
                               multiple
                               :action="uploadImgUrl"
                               :data="{file_type:2}"
                               list-type="picture-card"
                               :file-list="defFiles2"
                               :before-upload="beforeUpload"
                               :on-preview="previewImg"
                               :on-success="(response, file, fileList) =>{
                        this.defFiles2 = fileList;
                      }"
                               :on-remove="( file, fileList) =>{
                        this.defFiles2 = fileList;
                      }"
                               ref="uploadRef2">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <i class="el-icon-info">上传jpg、jpeg、png，且大小不能超过50M的图片</i>
                  </el-form-item>
                </td>
              </tr>

              <el-dialog :visible.sync="dialogVisible">
                <img width="100%"
                     :src="dialogImageUrl"
                     alt />
              </el-dialog>

              <tr class="remark-box">
                <h3>备注:</h3>
                <!-- <p>1、本人户口本或出生证明复印件、2寸照片1张</p> -->
                <p>1、患者贫困证明、残疾人证明、家庭情况照片证明、社区或民政开具的家庭低保/低收入证明；</p>
                <p>2、已由媒体报道过的相关图片/媒体素材；</p>
                <p>3、诊断病例或必要的病史证明材料</p>
                <p>4、执行机构开具的治疗费用发票</p>
              </tr>
              <tr class="service-box1">
                <td colspan="2">
                  <el-form-item label="上传所需附件：">
                    <el-upload class="upload-demo"
                               :action="uploadFileUrl"
                               multiple
                               :file-list="defFiles3"
                               :before-upload="fileBeforeUpload"
                               ref="uploadRef3"
                               :on-success="(response, file, fileList) =>{
                        this.defFiles3 = fileList;
                      }"
                               :on-remove="( file, fileList) =>{
                        this.defFiles3 = fileList;
                      }">
                      <el-button size="small"
                                 type="primary">点击上传</el-button>
                    </el-upload>
                    <i class="el-icon-info">上传格式：jpg、jpeg、png、doc、docx，且大小不能超过300M的附件</i>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2"
                    class="checkBox">
                  <!-- <div class="check-box">
                    <el-checkbox v-model="agreeChecked">我已阅读并同意</el-checkbox>
                    <span @click="getMask">《志愿者暂行管理办法》</span>
                  </div>-->

                  <el-button type="primary"
                             :disabled="btnDisabled"
                             style="background-color:#ccc;border-color:#ccc"
                             v-if="btnDisabled">提交</el-button>
                  <el-button type="primary"
                             @click="submitForm()"
                             v-else>提交</el-button>
                </td>
              </tr>
            </table>
          </el-form>
        </div>
      </div>
      <!-- <div class="center-footer">
        <div class="footer-content">
          <span>（建议您使用IE9及以上版本浏览器访问本网站）</span>
          <span>技术支持：长沙普益云软件科技有限公司</span>
        </div>
      </div>-->
    </div>
    <div class="mask-box"
         v-show="maskShow">
      <div class="content-box">
        <i @click="maskHidden">×</i>
        <div class="scoll-box"
             v-html="volunteerAg"></div>
      </div>
    </div>
    <home-foot></home-foot>
    <floating-button></floating-button>
  </div>
</template>
<script>
import Axios from "axios";
import baseUrl from "@/config/index";
import homeHead from "../Public/head";
import homeNav from "../Public/nav";
import homeFoot from "../Public/foot";
import floatingButton from "../Public/floatingButton";

export default {
  components: {
    homeHead,
    homeNav,
    homeFoot,
    floatingButton
  },
  data () {
    var checkUserCardno = (rule, value, callback) => {
      if (!value) {
        return callback();
      }

      var isValid = true;
      var cityCode = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
      };
      var rFormat = /^\d{6}(19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$|^\d{6}\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}$/; // 格式验证

      if (!rFormat.test(value) || !cityCode[value.substr(0, 2)]) {
        isValid = false;
      }
      // 18位身份证需要验证最后一位校验位
      else if (value.length === 18) {
        var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
        var Ci = "10X98765432"; // 校验字符
        // 加权求和
        var sum = 0;
        for (var i = 0; i < 17; i++) {
          sum += value.charAt(i) * Wi[i];
        }
        // 计算校验值
        var C17 = Ci.charAt(sum % 11);
        // 与校验位比对
        if (C17 !== value.charAt(17)) {
          isValid = false;
        }
      }
      if (!isValid) {
        return callback(new Error("请填写正确的身份证号码！"));
      } else {
        this.handleInfoReader();
        return callback();
      }
    };
    var checkDistinct = (rule, value, callback) => {
      if (this.form.province_id && this.form.city_id && this.form.county_id) {
        return callback();
      }

      return callback(new Error("请选择居住地址！"));
    };
    return {
      defFiles1: [],
      defFiles2: [],
      defFiles3: [],
      provinceList: [],
      cityList: [],
      countyList: [],
      p_provinceList: [],
      p_cityList: [],
      p_countyList: [],
      volunteerAg: "", //协议内容
      agreeChecked: true, //协议勾选
      btnDisabled: false, //提交按钮状态
      maskShow: false, //协议框
      // mustIds:[],

      //志愿者申请状态提示相关
      cueTitle: "",
      cueType: "info",
      cueDesc: "",
      unit_name: "",
      p_city_id: null, //所在执行机构地址
      p_county_id: null, //所在执行机构地址
      p_province_id: null, //所在执行机构地址
      apply_data: [], //救助类型字典

      uploadImgUrl: "",
      uploadFileUrl: "",

      dialogImageUrl: "", //大图片路径
      dialogVisible: false, //显示大图框

      specificHospital: [], //具体执行机构

      region1: [], //居住地区
      form: {
        age: "", //年龄
        jg: null, //籍贯
        user_name: "", //姓名
        user_sex: 1, //性别
        user_cardno: "", //身份证号
        description: "", //诊断结果
        revenue_sources: "", //收入来源
        // birthplace: "", //籍贯
        phone: "", //联系方式
        province_id: null, //省
        city_id: null, //市
        county_id: null, //县
        home_address: "", //联系地址
        family_year_income: "", //年收入
        apply_type: [], //申请人类别
        wechat_no: "",
        volunteer_phone: "", //经手志愿者联系方式
        volunteer_wechat: "",
        unit_id: "", //具体执行机构
        id: "",
        codePic: [], //身份证正反面
        householdPic: [], //户口本户主和本人照片
        files: [] //备注文件
      },

      ruleValidate: {
        user_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        province_id: [{ validator: checkDistinct }],
        unit_id: [
          {
            required: true,
            message: "请根据上面一行的执行机构所在地址，选择具体的执行机构",
            trigger: "change"
          }
        ],
        jg: [{ required: true, message: "请输入籍贯", trigger: "blur" }],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        volunteer_phone: [
          {
            required: true,
            message: "请输入经手志愿者联系方式",
            trigger: "blur"
          }
        ],
        user_sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        user_cardno: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          { validator: checkUserCardno, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    getMask () {
      this.maskShow = true;
      this.$db.post("website-getAgreementInfo", { type: 3 }).then(res => {
        if (res.code == 200) {
          this.volunteerAg = res.data;
        }
      });
    },

    //查看大图
    previewImg (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    beforeUpload (file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    //备注文件
    fileBeforeUpload (file) {
      let bool = this.$fnc.checkUploadFile(file);
      return bool;
    },

    maskHidden () {
      this.maskShow = false;
    },
    goto (name) {
      this.$router.push({ name: name });
    },

    //执行机构地址
    getCityHospital (value) {
      this.p_city_id = null;
      this.p_county_id = null;
      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then(resp => {
          this.p_cityList = resp.data;
        });

      this.getHospitalByAddress(
        this.p_province_id,
        this.p_city_id,
        this.p_county_id
      );
    },
    getCountyHospital (value) {
      this.p_county_id = null;
      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then(resp => {
          this.p_countyList = resp.data;
        });
      this.getHospitalByAddress(
        this.p_province_id,
        this.p_city_id,
        this.p_county_id
      );
    },
    changeCountryHospital () {
      this.getHospitalByAddress(
        this.p_province_id,
        this.p_city_id,
        this.p_county_id
      );
    },
    //居住地
    getCity (value, ifEdit = false) {
      if (!ifEdit) {
        this.form.city_id = null;
        this.form.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then(resp => {
          this.cityList = resp.data;
        });
    },
    getCounty (value, ifEdit = false) {
      if (!ifEdit) {
        this.form.county_id = null;
      }

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then(resp => {
          this.countyList = resp.data;
        });
    },
    //根绝省市县 获取具体的执行机构
    getHospitalByAddress (
      $province_id = "",
      $city_id = "",
      $county_id = "",
      $unit_id
    ) {
      this.form.unit_id = "";
      let params = {};
      params.province_id = $province_id;
      params.city_id = $city_id;
      params.county_id = $county_id;
      params.unit_id = $unit_id;
      this.$db.post(this.$db.config.getHospitalByAddress, params).then(res => {
        if (res.code == 200) {
          this.specificHospital = res.data;
        }
      });
    },
    // 读取身份证相关信息，并自动填充
    handleInfoReader () {
      // 渲染省市县、生日、性别、籍贯等信息
      // this.form.user_cardno = this.form.user_cardno.trim() // 字符串去前后两端空格的方法
      this.form.user_cardno = this.form.user_cardno.replace(/^ +| +$/g, "");
      let cardno = this.form.user_cardno;
      if (cardno.length === 18) {
        // 省市县渲染
        let province = cardno.substring(0, 2) + "0000";
        let city = cardno.substring(0, 4) + "00";
        let county = cardno.substring(0, 6);

        //出生年月
        let year2 = cardno.substring(6, 10);
        let month2 = cardno.substring(10, 12);
        let day2 = cardno.substring(12, 14);
        let birthday = year2 + "-" + month2 + "-" + day2;
        this.form.birthday = birthday;

        var date = new Date();
        var month = date.getMonth() + 1;
        var day = date.getDate();

        var age = date.getFullYear() - cardno.substring(6, 10) - 1;
        if (
          cardno.substring(10, 12) < month ||
          (cardno.substring(10, 12) == month && cardno.substring(12, 14) <= day)
        ) {
          age++;
        }
        this.form.age = age;
        // 性别
        let sex = cardno.substring(16, 17);
        this.$set(this.form, 'user_sex', Number(sex) % 2 == 0 ? 2 : 1);
      }
    },

    judeLogin () {
      let loginInfo = sessionStorage.getItem("token");
      if (loginInfo && loginInfo != "null") {
        sessionStorage.removeItem("backUrl");
        this.getApplyInfoPcDetail();
      } else {
        //未登录
        this.$confirm("系统检测到您暂未登录, 是否进行登录?", "登录提示", {
          confirmButtonText: "立即登录",
          cancelButtonText: "返回页面",
          type: "warning"
        })
          .then(() => {
            sessionStorage.setItem("backUrl", this.$route.fullPath);
            this.$router.push({ name: "login" });
          })
          .catch(() => {
            this.$router.push({ path: "/" });
            sessionStorage.removeItem("bread1");
            sessionStorage.removeItem("index");
          });
      }
    },
    //提交申请
    submitForm () {
      if (!sessionStorage.getItem("token")) {
        this.judeLogin();
      }

      if (
        this.defFiles1 &&
        this.defFiles2
      ) {
        this.$message.error("身份证和户口照片请两者选择一个");
        return false;
      }

      this.form.codePic = [];
      this.form.householdPic = [];
      this.form.files = [];

      //处理身份证照片集
      if (this.defFiles1.length > 0) {
        let arr1 = [];

        this.defFiles1.forEach((item, index) => {
          if (item.hasOwnProperty("response")) {
            arr1.push(item.response.data.id);
          } else {
            arr1.push(item.id);
          }
        });
        this.form.cardno_pic = arr1;
      }

      //处理户口本照片集
      if (this.defFiles2.length > 0) {
        let arr2 = [];

        this.defFiles2.forEach((item, index) => {
          if (item.hasOwnProperty("response")) {
            arr2.push(item.response.data.id);
          } else {
            arr2.push(item.id);
          }
        });
        this.form.household_pic = arr2;
      }

      //处理备注文件集
      if (this.defFiles3.length > 0) {
        let arr3 = [];

        this.defFiles3.forEach((item, index) => {
          if (item.hasOwnProperty("response")) {
            arr3.push(item.response.data.id);
          } else {
            arr3.push(item.id);
          }
        });
        this.form.files = arr3;
      }

      this.$refs["applyForm"].validate(valid => {
        if (valid) {
          let url = "";
          if (this.form.id) {
            url = this.$db.config.applyInfoEditPc;
          } else {
            url = this.$db.config.applyInfoAddPc;
          }

          this.$db.post(url, this.form).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                duration: 1000,
                message: res.msg,
                onClose: function () {
                  setTimeout(location.reload(), 500);
                }
              });
            }
          });
        } else {
          this.$message.error("请填写完整表单信息！");
        }
      });
    },
    getApplyInfoPcDetail () {
      this.$db.post(this.$db.config.applyInfoPcDetail, {}).then(res => {
        if (res.code == 200 && res.data.id) {
          this.getHospitalByAddress(null, null, null, res.data.unit_id);
          this.form = res.data;
          if (res.data.apply_type && res.data.apply_type.length > 0) {
            this.form.apply_type = res.data.apply_type.map(Number);
          }

          if (res.data.cardno_pic && res.data.cardno_pic.length > 0) {
            this.defFiles1 = res.data.cardno_pic_url;
          }

          if (res.data.household_pic && res.data.household_pic.length > 0) {
            this.defFiles2 = res.data.household_pic_url;
          }

          if (res.data.files && res.data.files.length > 0) {
            this.defFiles3 = res.data.fileList;
          }

          if (res.data.province_id && res.data.city_id) {
            this.getCity(res.data.province_id, true);
            this.getCounty(res.data.city_id, true);

            this.$set(this.form, "province_id", res.data.province_id);
            this.$set(this.form, "city_id", res.data.city_id);
            this.$set(this.form, "county_id", res.data.county_id);
          }

          this.$set(this.form, "unit_id", res.data.unit_id);

          // switch(res.data.audit_status){
          //     case 0:
          this.cueTitle = "待审核";
          this.cueType = "warning";
          this.cueDesc = "您的信息已提交，请耐心等待审核结果~";
          //     break;
          // }
        }
      });
    }
  },

  mounted () {
    this.judeLogin();

    //图片上传地址

    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;

    this.getCity(this.form.province_id);
    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then(resp => {
      this.provinceList = resp.data;
      this.p_provinceList = resp.data;
    });

    // //字典值
    this.$db
      .post(this.$db.config.getDictParam, {
        pid: "100220",
        table: "pub_type_param"
      })
      .then(res => {
        this.apply_data = res.data;
      });
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  // width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
  border: 1px solid #eee;
}
.inputBox {
  border: none;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid #eee;
  outline: none;
  padding: 6px;
  color: #666;
}
.center-box {
  margin-bottom: 100px;
  margin-top: 40px;
  .center-list {
    max-width: 1200px;
    margin: 0 auto;
    > h3 {
      font-size: 20px;
      padding: 22px 0;
      text-align: center;
      background-color: #fff;
      border-bottom: 1px solid #eee;
    }
    .center-left {
      background-color: #fff;
      width: 100%;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;
        > li {
          list-style: none;
          font-size: 14px;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .checkBox {
    position: relative;
    text-align: center;
    .check-box {
      text-align: center;
      margin-top: 20px;
      > span {
        color: #b60205;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .el-button--primary {
      background-color: #b60205;
      border-color: #b60205;
      margin: 20px 0;
    }
  }

  .comBox {
    > h3 {
      font-size: 18px;
      font-weight: normal;
      color: #333;
      text-align: center;
      padding: 12px 0;
    }
    > p {
      font-size: 16px;
      color: #666;
      padding: 12px 0;
      padding-left: 160px;
    }
    .perBox {
      padding: 12px 0;
      padding-bottom: 20px;
      text-align: right;
      font-size: 16px;
      color: #666;
      > input {
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
        border-bottom: 1px solid #eee;
        padding: 12px 8px;
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
  .table {
    width: calc(100% - 50px);
    margin: 20px 25px;
    > tr {
      .sort-box {
        > h3 {
          font-size: 18px;
          color: #333;
          padding: 12px 8px;
          background-color: #eee;
          width: calc(100%-16px);
          font-weight: normal;
        }
      }
    }
  }
  .table td {
    width: 50%;
    border-bottom: 1px dashed #eee;
  }
  .register_head {
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
    font-size: 14px;
    font-weight: 600;
    // font-family: "微软雅黑";
    color: DimGray;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    margin-right: 20px;
    //margin-bottom: 30px;
    .login {
      font-size: 12px;
      float: right;
      font-family: "微软雅黑";
      font-weight: 300;
      color: #ccc;
    }
  }
}
.mask-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  background: rgba(0, 0, 0, 0.8);
  .content-box {
    max-width: 1120px;
    margin: 5% auto;
    background-color: #fff;
    height: 80%;
    position: relative;
    padding: 0 40px;
    overflow: hidden;
    > i {
      position: absolute;
      top: 6px;
      right: 20px;
      color: #333;
      font-size: 50px;
      cursor: pointer;
    }
    .scoll-box {
      padding: 0 80px;
      margin: 5% 0;
      height: 85%;
      overflow-y: scroll;
      > h3 {
        font-size: 20px;
        color: #000;
        text-align: center;
        padding: 20px;
      }
      > h5 {
        font-size: 18px;
        color: #333;
        text-align: center;
        padding: 20px;
      }
      > h6 {
        font-size: 18px;
        color: #333;
        text-align: right;
        padding: 20px;
      }
      > p {
        font-size: 16px;
        color: #666;
        line-height: 30px;
        margin-bottom: 20px;
      }
    }
    .scoll-box::-webkit-scrollbar {
      display: none;
    }
  }
}
.remark-box {
  > h3 {
    font-weight: normal;
    font-size: 20px;
    color: #333;
    padding-left: 40px;
  }
  > p {
    font-size: 16px;
    color: #666;
    padding-left: 80px;
  }
}
.service-box /deep/ .el-form-item__content {
  margin-left: 200px !important ;
}
.service-box /deep/ .el-form-item__label {
  width: 200px !important;
  margin-top: 4px;
  text-align: center;
}
.service-box1 /deep/ .el-form-item__content {
  margin-left: 240px !important ;
}
.service-box1 /deep/ .el-form-item__label {
  width: 240px !important;
  margin-top: 4px;
  text-align: center;
}
.center-box /deep/ .el-steps--simple {
  padding: 22px 8%;
  background-color: #eee;
}
.center-box /deep/ .el-form-item {
  margin-bottom: 0;
  margin: 12px 0;
}
.center-box /deep/ .el-input__inner:focus {
  border-color: #b60205;
}
.center-box /deep/ .el-textarea__inner:focus {
  border-color: #b60205;
}
.center-box /deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #b60205;
}
.center-box /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #b60205;
  background: #b60205;
}
.center-box /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #b60205;
}
.center-box /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #b60205;
  background: #b60205;
}
.center-box /deep/ .el-checkbox__inner:hover {
  color: #b60205;
}
.upload_box /deep/ .el-upload-dragger {
  width: 210px;
  height: 108px;
  margin: 8px 0 0px 178px;
}
.upload_box /deep/ .el-upload-dragger .el-icon-upload {
  margin-top: 8px;
}
.upload_box /deep/ .el-upload__tip {
  margin-top: 0;
  text-align: center;
}
.service-box1 /deep/ .el-upload__tip {
  text-align: left;
  font-size: 14px;
  margin-top: -6px;
}

input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Apply/apply_index.vue